import React, { useEffect, useState } from "react";
import {
    Container,
    Paper,
    Grid,
    FormGroup,
    FormLabel,
    FormControlLabel,
    Checkbox,
    TextField,
    Switch,
    Button,
    FormControl,
    Typography,
    useTheme,
    useMediaQuery,
    CircularProgress,
    ListItemText,
    Select,
    MenuItem,
} from "@material-ui/core";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Tooltip } from "@mui/material";
import IconButton from "@material-ui/core/IconButton";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import Share from "@mui/icons-material/Share";
import constants from "../../../utils/constants";
import { showSuccessToast, getCustomLabel } from "../../../common/components/Helper/Utils";
import RssFeedIcon from '@mui/icons-material/RssFeed';
import "../../../components/pages/dashboard/style/style.css";
import { fetchRss } from '../../Auth/reducer/actions';
import { SpinnerRoundFilled } from "spinners-react";
import {
    createRssFieldSetting,
    getInventorySettingBusiness
} from "./actions/administration";


const InventoryTypeMethods = [
    "Regular Inventory",
    "Memo Inventory",
    "Partnership Inventory",
    "Consignment Inventory",
]

const InventoryStatusMethods = [
    "Incoming",
    "Needs Service / Polish",
    "At Service",
    "Intake Complete",
    "Need to Post",
    "Invoiced",
    "Inhand",
    "Out on Memo",
    "On Hold / Reserved",
    "Need to Ship",
    "Shipped waiting on payment",
    "Sold & Cashed Out",
    "Available to Order",
]

export default function RssFeed() {
    const [labelsVersion, setLabelsVersion] = useState(0);
    const [rssPopupOpen, setRssPopupOpen] = useState(false);
    const [conditions, setConditions] = useState([]); 
    const [inventoryTypes, setInventoryTypes] = useState([]); 
    const [InventoryStatus, setInventoryStatus] = useState([]); 
    const [serialConsent, setSerialConsent] = useState(false);
    const [rssConsentLoading, setRssConsentLoading] = useState(false);
    const [initialConsent, setInitialConsent] = useState(false);
    const [rssLoading, setRssLoading] = useState(false);
    const [loader, setloader] = useState(true);
    const handleCheckboxChange = (e) => {
        setSerialConsent(e.target.checked);
    };

    const USED_GOOD = getCustomLabel("custom_used_good", "Used/Good");
    const MINT_VERY_GOOD = getCustomLabel("custom_mint_verygood", "Mint/Very Good");
    const RETAIL_READY = getCustomLabel("custom_retail_likenew", "Retail Ready/Like New");
    const NEW_COND = getCustomLabel("custom_new", "New");
    const conditionMethods = [USED_GOOD, MINT_VERY_GOOD, RETAIL_READY, NEW_COND];
    const handleSerialConsent = async (e) => {
        // const checked = e.target.checked;
        //  setSerialConsent(checked);
         setRssLoading(true);
       const accountid = window.sessionStorage.getItem("accountId");
       const payload = {
        accountid,
        isdealerfeed_enabled: true,
        isserialno_consent: serialConsent,

        // Condition
        used_good: conditions.includes(getCustomLabel("custom_used_good", "Used/Good")),
        mint_very_good: conditions.includes(getCustomLabel("custom_mint_verygood", "Mint/Very Good")),
        retail_ready_like_new: conditions.includes(getCustomLabel("custom_retail_likenew", "Retail Ready/Like New")),
        new_condition: conditions.includes(getCustomLabel("custom_new", "New")),

        // Inventory Type
        regular_inventory: inventoryTypes.includes("Regular Inventory"),
        memo_inventory: inventoryTypes.includes("Memo Inventory"),
        partnership_inventory: inventoryTypes.includes("Partnership Inventory"),
        consignment_inventory: inventoryTypes.includes("Consignment Inventory"),

        // Inventory Status
        in_hand: InventoryStatus.includes("Inhand"),
        in_coming: InventoryStatus.includes("Incoming"),
        outon_memo: InventoryStatus.includes("Out on Memo"),
        on_hold_reserved: InventoryStatus.includes("On Hold / Reserved"),
        available_to_order: InventoryStatus.includes("Available to Order"),
        needs_service_polish: InventoryStatus.includes("Needs Service / Polish"),
        at_service: InventoryStatus.includes("At Service"),
        need_to_ship: InventoryStatus.includes("Need to Ship"),
        shipped_waiting_payment: InventoryStatus.includes("Shipped waiting on payment"),
        sold_cashed_out: InventoryStatus.includes("Sold & Cashed Out"),
        intake_complete: InventoryStatus.includes("Intake Complete"),
        invoice_id: InventoryStatus.includes("Invoiced"),
        need_to_post: InventoryStatus.includes("Need to Post")
        };
       createRssFieldSetting(payload, (err, res) => {
        setRssLoading(false);
        if (err) {
            toast.error("RSS field creation failed", {
                position: "bottom-center"
            });   
        } else {
            toast.success("RSS fields saved successfully", {
                position: "bottom-center"
            });
            setTimeout(() => {
                getRss();
            }, 300);
        }
        });
        setRssConsentLoading(false);
    };
     const getRss = () => {
        const userDetails = window.sessionStorage.getItem("userDetails")
         ? JSON.parse(window.sessionStorage.getItem("userDetails"))
         : null;
        let companyName = userDetails?.accountName?.replace(/[\s.]/g, "");
        const baseURL = `${constants.BASE_URL}rss/products.xml?company=${companyName}`;
         alert(baseURL);
         window.open(baseURL, "_blank");
         setRssPopupOpen(false);
    };
    const getRssUrl = () => {
        const userDetails = window.sessionStorage.getItem("userDetails")
            ? JSON.parse(window.sessionStorage.getItem("userDetails"))
            : null;

        let companyName = userDetails?.accountName?.replace(/[\s.]/g, "");

        return `${constants.BASE_URL}rss/products.xml?company=${companyName}`;
    };
    useEffect(() => {
     loadRssSettings();
     const onLabelsUpdated = () => setLabelsVersion((v) => v + 1);
     window.addEventListener("customLabelsUpdated", onLabelsUpdated);
     return () => window.removeEventListener("customLabelsUpdated", onLabelsUpdated);
    }, []);
    useEffect(() => {



        if (conditionMethods.length > 0) {
            setConditions(conditionMethods);
        }
        setInventoryTypes(InventoryTypeMethods);
        setInventoryStatus(InventoryStatusMethods);
    }, [labelsVersion]);
    const loadRssSettings = () => {
        setloader(true);
    const accountid = window.sessionStorage.getItem("accountId");

    getInventorySettingBusiness((err, res) => {
        if (!err && res && res.data) {

            const data = res.data;

            // let cond = [];
            // if (data.used_good) cond.push(USED_GOOD);
            // if (data.mint_very_good) cond.push(MINT_VERY_GOOD);
            // if (data.retail_ready_like_new) cond.push(RETAIL_READY);
            // if (data.new_condition) cond.push(NEW_COND);

            // setConditions(cond);

            let types = [];
            if (data.regular_inventory) types.push("Regular Inventory");
            if (data.memo_inventory) types.push("Memo Inventory");
            if (data.partnership_inventory) types.push("Partnership Inventory");
            if (data.consignment_inventory) types.push("Consignment Inventory");

            setInventoryTypes(types);

            let status = [];
            if (data.in_hand) status.push("Inhand");
            if (data.in_coming) status.push("Incoming");
            if (data.outon_memo) status.push("Out on Memo");
            if (data.on_hold_reserved) status.push("On Hold / Reserved");
            if (data.available_to_order) status.push("Available to Order");
            if (data.needs_service_polish) status.push("Needs Service / Polish");
            if (data.at_service) status.push("At Service");
            if (data.need_to_ship) status.push("Need to Ship");
            if (data.shipped_waiting_payment) status.push("Shipped waiting on payment");
            if (data.sold_cashed_out) status.push("Sold & Cashed Out");
            if (data.intake_complete) status.push("Intake Complete");
            if (data.invoice_id) status.push("Invoiced");
            if (data.need_to_post) status.push("Need to Post");

            setInventoryStatus(status);

            setSerialConsent(data.isserialno_consent === undefined ? true : data.isserialno_consent);
            setInitialConsent(data.isserialno_consent === undefined ? true : data.isserialno_consent)
        }
            setloader(false);
    });
};
    if (loader) {
            return (
                <div className="d-spinner">
                    <SpinnerRoundFilled
                        size={51}
                        thickness={125}
                        speed={80}
                        color="rgba(57, 107, 172, 1)"
                        className="spp"
                        enabled={loader}
                    />
                </div>
                );
    }
    return (
            <Container maxWidth="lg" className="space-3">
                <Paper className="border-radius">
                    <form
                        className="padding"
                        onSubmit={(e) => {
                            e.preventDefault();
                        }}
                        id="subscribe_user_update_form"
                    >
                        <Grid container spacing={1}>
                        <Grid item>
                           <Typography
                             variant="h6"
                             component="h6"
                             className="primary-text uppercase"
                           >
                          CHRONOGRID RSS
                           </Typography>
                        </Grid>
                        {initialConsent && (
                            <Grid item style={{display: 'flex', gap: '15px', paddingLeft:'20px'}}>    
                            <Tooltip title="Copy URL">
                            <IconButton
                                size="small"
                                onClick={() => {
                                const url = getRssUrl();
                                // navigator.clipboard.writeText(this.state.shopifyUrl);
                                copy(url);
                                showSuccessToast("Copied to clipboard");
                                }}
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                            </Tooltip>

                            <Tooltip title="Open URL">
                            <IconButton
                                size="small"
                                onClick={() => {
                                    const url = getRssUrl();
                                    window.open(url, "_blank");
                                }}
                            >
                                <OpenInNewIcon fontSize="small" />
                            </IconButton>
                            </Tooltip>
                        </Grid>
                     )}
                       <Grid item xs={12} columnSpacing={3} rowSpacing={1}>
                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 600, marginBottom: 12 }}
                        >
                            Condition
                        </Typography>
                        <Grid container columnSpacing={3} rowSpacing={1}>
                            {conditionMethods.map((item) => (
                            <Grid item xs={12} sm={6} md={3} key={item}>
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={conditions.includes(item)}
                                    onChange={() => {
                                        if (conditions.includes(item)) {
                                        setConditions(conditions.filter((c) => c !== item));
                                        } else {
                                        setConditions([...conditions, item]);
                                        }
                                    }}
                                    color="primary"
                                    />
                                }
                                label={item}
                                />
                            </Grid>
                            ))}
                        </Grid>
                        </Grid>
                        {conditions.length === 0 && (
                        <Grid item xs={12}>
                           <span style={{ color: "red", fontSize: "12px" }}>
                             Please select at least one Condition
                           </span>
                        </Grid>
                        )}

                        <Grid item xs={12} columnSpacing={3} rowSpacing={1}>

                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 600, marginBottom: 12 }}
                        >
                            Inventory Type
                        </Typography>

                        <Grid container columnSpacing={3} rowSpacing={1}>
                            {InventoryTypeMethods.map((item) => (
                            <Grid item xs={12} sm={6} md={3} key={item}>
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={inventoryTypes.includes(item)}
                                    onChange={() => {
                                        if (inventoryTypes.includes(item)) {
                                        setInventoryTypes(inventoryTypes.filter((c) => c !== item));
                                        } else {
                                        setInventoryTypes([...inventoryTypes, item]);
                                        }
                                    }}
                                    color="primary"
                                    />
                                }
                                label={item}
                                />
                            </Grid>
                            ))}
                        </Grid>
                        </Grid>
                        {inventoryTypes.length === 0 && (
                        <Grid item xs={12}>
                           <span style={{ color: "red", fontSize: "12px" }}>
                             Please select at least one Inventory Type
                           </span>
                        </Grid>
                        )}
                        <Grid item xs={12} columnSpacing={3} rowSpacing={1}>
                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 600, marginBottom: 8 }}
                        >
                            Inventory Status
                        </Typography>

                        <Grid container columnSpacing={3} rowSpacing={1}>
                            {InventoryStatusMethods.map((item) => (
                            <Grid item xs={12} sm={6} md={3} key={item}>
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={InventoryStatus.includes(item)}
                                    onChange={() => {
                                        if (InventoryStatus.includes(item)) {
                                        setInventoryStatus(
                                            InventoryStatus.filter((c) => c !== item)
                                        );
                                        } else {
                                        setInventoryStatus([...InventoryStatus, item]);
                                        }
                                    }}
                                    color="primary"
                                    />
                                }
                                label={
                                  item === "Need to Post" ? (
                                    <em>{item}</em>
                                  ) : (
                                    item
                                  )
                                }
                                />
                            </Grid>
                            ))}
                        </Grid>
                        </Grid>
                        {InventoryStatus.length === 0 && (
                        <Grid item xs={12}>
                           <span style={{ color: "red", fontSize: "12px" }}>
                             Please select at least one Inventory Status
                           </span>
                        </Grid>
                        )}
                       <Grid item xs={12}>
                         <Grid>
                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                Serial Number Consent
                            </Typography>
                            </Grid>
                        <Grid container alignItems="center"> 
                         <Grid item>
                            <Checkbox
                                checked={serialConsent}
                                onChange={handleCheckboxChange}
                                color="primary"
                            />
                            </Grid>
                            <Grid item xs>
                                <p
                                style={{
                                    color: "#555",
                                    fontSize: "13px",
                                    fontStyle: "italic",                                    
                                }}
                                >
                                RSS feed integration with <b>CHRONOGRID requires your serial numbers
                                to be shared with their platform.</b> WatchOps cannot assume responsibility
                                for the security or misuse of serial numbers outside our system.
                                If you disagree with this requirement, please decline joining the service.
                                </p>
                            </Grid>
                        </Grid>         
                        </Grid>
                        <Grid item xs={12}style={{ marginTop: 15, marginBottom: 10 }}>
                        <Button variant='contained' className="text-capitalize primary-bg color-white" style={{ marginLeft: "200px" }}
                            onClick={handleSerialConsent}
                            disabled={
                                rssLoading ||
                                !serialConsent ||
                                conditions.length === 0 ||
                                inventoryTypes.length === 0 ||
                                InventoryStatus.length === 0
                            }
                        >
                          <RssFeedIcon />
                            Generate RSS Feed Link

                            {rssLoading && (
                                <CircularProgress size={20} style={{ color: "#fff" }} />
                            )}
                        </Button>
                        </Grid>
                        </Grid>
                    </form>
                </Paper>
            </Container>
        );
}